import React, { useEffect, useState } from 'react'
import { setting } from "../../Common/setting"
import Slider from 'react-slick'
import NotificationItem from '../../Components/NotificationItem/NotificationItem'
import { useDispatch, useSelector } from 'react-redux'
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
import { fetchuserAds } from '../../features/User/UserAction'
import "../../Components/AdsDetails/AdsDetails.css"

export default function Notification() {

    const dispatch = useDispatch();

    const { BookWormUser } = useSelector((state) => state)
    const { ads } = BookWormUser.userInfo
    const [negotiationAds,setNegotiationAds] = useState([]);

    useEffect(() => {

      dispatch(fetchuserAds(1));

      console.log("ads in user notifi : ",ads)
      setNegotiationAds(ads.negotiation);
      console.log("negotiation ads in user notifi : ",negotiationAds)

      
    }, [])
    
  return (
      <div className='Notification'>
        <Navbar colorLeft="#5f2c3e" colorRight="#5f2c3e" />
        <div className='Ad-container'>
              <h2>Notifications </h2>
                {
                  (negotiationAds.length === 0) && <h3 style={{color:"#fae5df"}} >No Pending Notifications Found</h3>
                }
                {(negotiationAds.length <=3)? 
                <div className='row'>
                    {
                        negotiationAds.map((element) => {
                        console.log(element)
                        return (
                        <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                                <NotificationItem name={element.name} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0]} quotedPrice={element.quotedPrice} message = {element.message} id = {element._id} images={element.images}/>
                        </div>
                         
                        )})
                    }
                </div>:

                <Slider {...setting}>
                {
                    negotiationAds.map((element) => {
                     console.log(element)
                        return (
                            <NotificationItem name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0]} quotedPrice={element.quotedPrice} message={element.message} id = {element._id} accepted = {element.accepted} images = {element.images}/>
                    )})
                }
                </Slider>
                }
        </div>
        <Footer/>
    </div>
  )
}
